<template>
    <div role="group" class="form-group">
        <label class="">{{ title }}</label>
        <input v-if="isLocalFile" class="form-control p-1" ref="customInput" type="file" :accept="this.accept" @change="onFileSelect" />
        <div v-else class="d-flex form-control justify-content-between">
            <a :href="filePath" target="_blank" download>{{$t("download")}}</a>
            <a class="cursor-pointer" @click="removeFile"><u>{{$t("remove")}}</u></a>
        </div>
        <div class="invalid-feedback">{{invalidFeedback}}</div>
    </div>
</template>

<script>
import { API_HELPER } from "@/helpers/api.js";
import { convertToBase64 } from "@/helpers/utils.js";

const MAX_SIZE = 5; // MB

export default {
    computed:
    {
        filePath: function()
        {
            return this.value ? API_HELPER.pathJoin([process.env.VUE_APP_URL_ROOT, this.value]) : null;
        },
        isLocalFile: function()
        {
            return !this.value || this.value.data;
        }
    },
    props:{
        value: null,
        title: String,
        mime: {
            type: String,
            default: "file/pdf"
        },
        accept: {
            type: String,
            default: ".pdf"
        },
        invalidFeedback:
        {
            type: String,
            default: null
        }
    },
    methods:
    {
        onFileSelect(e) {
            try
            {
                var file = e.target.files[0];
                const maxSize = 1024 * 1024 * MAX_SIZE;

                // Validations
                if(file.size > maxSize)
                {
                    throw this.$t('fileErrorMessage');
                }

                convertToBase64(file)
                .then(base64 =>{
                    this.$emit('input', {mime: this.mime , data: base64.split(',')[1] });
                });
            }
            catch(err)
            {
                e.target.value = '';
                alert(err);
            }
        },
        removeFile()
        {
            this.$emit('input', null);
        }
    },
}
</script>

<style scoped>
.form-group.is-invalid input {
    border-color: #dc3545;
}

.form-group.is-invalid .invalid-feedback {
    display: block;
}
</style>